import { Mail, MapPin, Phone } from 'lucide-react';
import Container from './Container';
import { logoUrl, telHref, useSite } from '../../utils/site';

export default function Footer() {
  const year = new Date().getFullYear();
  const site = useSite();

  return (
    <footer className="border-t border-brand-green-100 bg-brand-green-950 text-brand-green-100">
      <Container className="grid gap-10 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <a href="/#home" className="flex items-center gap-3">
            <img src={logoUrl(site)} alt="Sri KalpaGavya logo" className="h-12 w-auto object-contain shrink-0 rounded bg-white p-0.5" />
            <span className="text-lg font-bold text-white">
              Sri Kalpa<span className="text-brand-gold-400">Gavya</span>
            </span>
          </a>
          <p className="mt-4 text-sm leading-relaxed text-brand-green-200">
            Nurturing Life, Harvesting Prosperity — an integrated dairy, livestock and sustainable farming
            enterprise delivering pure, ethical, farm-fresh products.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-brand-gold-400">Quick Links</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            {[
              { id: 'about', label: 'About Us' },
              { id: 'products', label: 'Products' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'partners', label: 'Our Partners' },
              { id: 'help', label: 'Help / FAQ' },
            ].map((l) => (
              <li key={l.id}>
                <a href={`/#${l.id}`} className="text-brand-green-200 transition-colors hover:text-white">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-brand-gold-400">Product Lines</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-brand-green-200">
            <li>Cow Milk — Fresh Dairy Milk</li>
            <li>Dairy By-Products — Paneer, Ghee, Curd, Butter</li>
            <li>Hen Eggs — Farm-Fresh Eggs</li>
            <li>Sheep Meat — Quality Sheep Meat</li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-brand-gold-400">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-brand-green-200">
            <li className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold-400" />
              <span>{site.address}</span>
            </li>
            {site.phone && (
              <li className="flex items-center gap-2.5">
                <Phone className="h-4 w-4 shrink-0 text-brand-gold-400" />
                <a href={telHref(site.phone)} className="hover:text-white">{site.phone}</a>
              </li>
            )}
            {site.email && (
              <li className="flex items-center gap-2.5">
                <Mail className="h-4 w-4 shrink-0 text-brand-gold-400" />
                <a href={`mailto:${site.email}`} className="hover:text-white">{site.email}</a>
              </li>
            )}
          </ul>
        </div>
      </Container>

      <div className="border-t border-brand-green-800">
        <Container className="flex flex-col items-center justify-between gap-2 py-5 text-xs text-brand-green-300 sm:flex-row">
          <p>© {year} Sri KalpaGavya Dairy and Farms LLP. All rights reserved.</p>
          <p>Est. 2026 · www.srikalpagavyadairyandfarms.com</p>
        </Container>
      </div>
    </footer>
  );
}
